var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('p',[_vm._v("© Copyright 2020 | Jyga Technologies inc. "+_vm._s(_vm.$t('allRights')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }